import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';

@Pipe({
    name: 'luxonFromNow',
    standalone: false
})
export class LuxonFromNowPipe implements PipeTransform {
    transform(value: DateTime | string) {
        if (!value) {
            return '';
        }
    
        const dt = typeof value === 'string' ? DateTime.fromISO(value) : value;
        return dt.toRelative();
    }
}
